import * as types from "./actionTypes";

export const remove = (id, {goBack = false}) => {
  return {
    type: types.API_REMOVE_RECEIVE_REQUEST,
    id,
    goBack
  };
};

export const removeSuccess = (data, deletedItemId) => {
  return {
    type: types.API_REMOVE_RECEIVE_SUCCESS,
    payLoad: { data, deletedItemId }
  };
};
export const removeFailure = (data, deletedItemId) => {
  return {
    type: types.API_REMOVE_RECEIVE_FAILURE,
    payLoad: { data, deletedItemId }
  };
};

export const removeSubject = id => {
  return {
    type: types.REMOVE_RECEIVE_SUBJECT_REQUEST,
    id
  };
};
export const removeSubjectSuccess = data => {
  return {
    type: types.REMOVE_RECEIVE_SUBJECT_SUCCESS,
    payLoad: { data, inProcess: false }
  };
};
export const removeSubjectFailure = data => {
  return {
    type: types.REMOVE_RECEIVE_SUBJECT_FAILURE,
    payLoad: { data, inProcess: false }
  };
};

export const updateSubject = (id, data) => {
  return {
    type: types.UPDATE_RECEIVE_SUBJECT_REQUEST,
    id,
    data
  };
};
export const updateSubjectSuccess = (id, data) => {
  return {
    type: types.UPDATE_RECEIVE_SUBJECT_SUCCESS,
    id,
    data
  };
};
export const updateSubjectFailure = () => {
  return {
    type: types.UPDATE_RECEIVE_SUBJECT_FAILURE
  };
};

export const getReceiveSubject = () => {
  return {
    type: types.GET_RECEIVE_SUBJECT_REQUEST
  };
};

export const getSubjectSuccess = data => {
  return {
    type: types.GET_RECEIVE_SUBJECT_SUCCESS,
    payLoad: { subjects: data, loading: false }
  };
};

export const storeReceiveSubject = data => {
  return {
    type: types.STORE_RECEIVE_SUBJECT_REQUEST,
    data: data
  };
};

export const storeReceiveSubjectSuccess = data => {
  return {
    type: types.STORE_RECEIVE_SUBJECT_SUCCESS,
    data
  };
};
export const storeReceiveSubjectFailure = () => {
  return {
    type: types.STORE_RECEIVE_SUBJECT_FAILURE
  };
};

export const store = (data, files) => {
  return {
    type: types.STORE_RECEIVE_REQUEST,
    data: data,
    files: files
  };
};
export const storeSuccess = () => {
  return {
    type: types.STORE_RECEIVE_SUCCESS
  };
};
export const storeFailure = () => {
  return {
    type: types.STORE_RECEIVE_FAILURE
  };
};

export const getRequest = id => {
  return {
    type: types.GET_RECEIVE_REQUEST,
    id
  };
};
export const getSuccess = data => {
  return {
    type: types.GET_RECEIVE_SUCCESS,
    payLoad: data
  };
};
export const getFailure = () => {
  return {
    type: types.GET_RECEIVE_FAILURE
  };
};

export const updateRequest = (id, data, files) => {
  return {
    type: types.UPDATE_RECEIVE_REQUEST,
    id,
    data,
    files
  };
};
export const updateSuccess = data => {
  return {
    type: types.UPDATE_RECEIVE_SUCCESS,
    payLoad: data
  };
};
export const updateFailure = () => {
  return {
    type: types.UPDATE_RECEIVE_FAILURE
  };
};
